import React from 'react';
import { Box, Popover, Typography } from '@mui/material';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { Colors } from '../../../theme/colors';
import {
  formatDateMonthToString,
  formatDateToString,
  formatStringToDate,
  parseHumanDateToISO,
} from '../../../utils/dateFormatter';
import CustomCalendarNew from '../../customCalendar/CustomCalenderNew';
import { ReactComponent as CalenderIcon } from '../../../images/icons/CalenderIcon.svg';
import moment from 'moment';

interface Props {
  isEdit?: boolean;
  startDate: string;
  endDate: string;
  pageType?: string;
  setStartDate: (startDate: string) => void;
  setEndDate: (startDate: string) => void;
  commencementDate: (date: Date) => void;
  completionDate: (date: Date) => void;
}
const DateSelectorCustom = (props: Props) => {
  const stDate = formatDateToString(props.startDate?.split('T')[0]);
  const edDate = formatDateToString(props.endDate?.split('T')[0]);


  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          placeContent: 'end',
          pointerEvents: props.pageType === 'create' ? 'auto' : 'none',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            width: props.pageType === 'create' ? '400px' : '350px',
          }}
        >
          <Typography
            color={Colors.black}
            fontSize={'14px'}
            variant='h6'
          >
            When you do want to start recruiting for this role?
          </Typography>
          <Box
            sx={{
              height: '40px',
              background: Colors.background_grey,
              borderRadius: '8px',
            }}
          >
            <PopupState variant='popover' popupId='startDate'>
              {(popupState: any) => (
                <>
                  <Box
                    sx={{
                      backgroundColor: 'transparent',
                      display: 'flex',
                      justifyContent: 'space-between',
                      height: '100%',
                      borderRadius: 2,
                      alignItems: 'center',
                      cursor: 'pointer',
                      paddingX: '8px',
                    }}
                    {...bindTrigger(popupState)}
                  >
                    <Box>
                      <Typography
                        variant={'body1'}
                        color={Colors.grey}
                        sx={{
                          fontSize: 12,
                          padding: 0,
                          color: Colors.outerSpace,
                        }}
                      >
                        {props.startDate == 'Invalid date' || props.startDate == '' || props.startDate == undefined
                          ? 'Start Date'
                          : stDate}
                      </Typography>
                    </Box>
                    <CalenderIcon
                      style={{
                        width: props.pageType === 'edit' ? '14px' : '18px',
                      }}
                    />
                  </Box>
                  <Popover
                    {...bindPopover(popupState)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    style={{ borderRadius: 20 }}
                  >
                    <CustomCalendarNew
                      onClose={popupState.close}
                      date={props?.startDate ? parseHumanDateToISO(props?.startDate) : formatDateToString(new Date())}
                      onReset={() => {
                        props.commencementDate(new Date());
                        props.setStartDate(formatDateMonthToString(new Date()));
                        const endDate = moment().add(1, "month").format("YYYY-MM-DD");
                        props.setEndDate(endDate);
                        popupState.close();
                      }}
                      onApply={(startDate: string) => {
                        props.commencementDate(formatStringToDate(startDate));
                        props.setStartDate(startDate);
                        const endDate = moment(parseHumanDateToISO(startDate)).add(1, "month").format("YYYY-MM-DD");
                        props.setEndDate(endDate);
                        popupState.close();
                      }}

                      minDate={
                        props.startDate
                          ? new Date(parseHumanDateToISO(props?.startDate))
                          : new Date()
                      }
                    />
                  </Popover>
                </>
              )}
            </PopupState>
          </Box>
        </Box>

        <Box
          sx={{
            height: '1px',
            borderBottomColor: Colors.grey_border,
            borderBottomWidth: 1,
            borderBottomStyle: 'solid'
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            width: props.pageType === 'create' ? '400px' : '350px',
          }}
        >
          <Typography
            sx={{ marginTop: '15px' }}
            color={Colors.black}
            fontSize={'14px'}
            variant='h6'
          >
            When do you want to end the recruiting of this role?
          </Typography>
          <Box
            sx={{
              height: '40px',
              background: Colors.background_grey,
              borderRadius: '8px',
            }}
          >
            <PopupState variant='popover' popupId='endDate'>
              {(popupState: any) => (
                <>
                  <Box
                    sx={{
                      backgroundColor: 'transparent',
                      justifyContent: 'space-between',
                      display: 'flex',
                      paddingX: '8px',
                      height: '100%',
                      borderRadius: 2,
                      alignItems: 'center',
                      cursor: 'pointer',
                      // borderBottom: '1px solid #D0D0D0'
                    }}
                    {...bindTrigger(popupState)}
                  >
                    <Typography
                      variant={'body1'}
                      color={Colors.grey}
                      sx={{
                        fontSize: 12,
                        padding: 0,
                        color: Colors.outerSpace,
                      }}
                    >
                      {props.endDate == 'Invalid date' || props.endDate == '' || props.endDate == undefined
                        ? 'End Date'
                        : edDate}
                    </Typography>
                    <CalenderIcon
                      style={{
                        width: props.pageType === 'edit' ? '14px' : '18px',
                      }}
                    />
                  </Box>
                  <Popover
                    {...bindPopover(popupState)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    style={{ borderRadius: 20 }}
                  >
                    <CustomCalendarNew
                      onClose={popupState.close}
                      date={
                        props?.endDate
                          ? parseHumanDateToISO(props?.endDate)
                          : moment().add(1, "month").toDate()
                      }
                      onReset={() => {
                        props.commencementDate(new Date());
                        props.setStartDate(formatDateMonthToString(new Date()));
                        const endDate = moment().add(1, "month").format("YYYY-MM-DD");
                        props.setEndDate(endDate);
                        popupState.close();
                      }}
                      onApply={(endDate: string) => {
                        props.completionDate(formatStringToDate(endDate));
                        props.setEndDate(endDate);
                        popupState.close();
                      }}
                      minDate={
                        props.startDate
                          ? new Date(parseHumanDateToISO(props.startDate))
                          : new Date()
                      }
                      maxDate={
                        props.endDate
                          ? new Date(parseHumanDateToISO(props.endDate))
                          : moment().add(1, "month").toDate()
                      }
                    />

                  </Popover>
                </>
              )}
            </PopupState>
          </Box>
        </Box>

        <Box
          sx={{
            height: '1px',
            borderBottomColor: Colors.grey_border,
            borderBottomWidth: 1,
            borderBottomStyle: 'solid'

          }}
        />
      </Box>
    </>
  );
};

export default DateSelectorCustom;
